module.exports = __webpack_public_path__ + "img/break_black.673b7efa.svg";